<script>
import { mapState, mapActions } from "vuex";

export default {
	name: "masterStasiForm",
	data() {
		return {
			mode: "INSERT",
			myData: {},
			show: true,
			showImages: false,
			message: "",
			myOptions: {
				jenis: {
					lingkungan: "Lingkungan",
					stasi: "Stasi",
				},
			},
			params: {},
			headers: {},
			imgDataUrl: "",
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			myWilayah: (state) => state.service.wilayah,
		}),
		getWilayah() {
			let total = {};

			// eslint-disable-next-line no-unused-vars
			Object.entries(this.myWilayah).forEach(([key, val]) => {
				total[val.id] = val.nama;
			});
			return total;
		},
	},
	created() {
		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			console.log(parseInt(this.$route.params.id));

			this.myData = this.$store.getters["masterStasi/getById"](
				parseInt(this.$route.params.id)
			);

			console.log(this.myData);

			if (!this.myData) {
				this.$router.push("/stasi");
			}
		} else {
			this.myData.nama = this.$faker().name.findName();
			this.myData.pelindung = this.$faker().name.findName();
			this.myData.ketua = this.$faker().name.findName();
			this.myData.sekretaris = this.$faker().name.findName();
			this.myData.bendahara = this.$faker().name.findName();

			this.myData.ketua_nohp = this.$faker().phone.phoneNumber();
			this.myData.sekretaris_nohp = this.$faker().phone.phoneNumber();
			this.myData.bendahara_nohp = this.$faker().phone.phoneNumber();
		}
      this.findAll();
		// this.params = { uid: this.myData.uid };
		// this.headers = APIService.getHeader();
	},
	methods: {
		// ...mapActions("pengguna", ["insert", "update"]),
		...mapActions({
			insert: "masterStasi/insert",
			update: "masterStasi/update",
		}),
		onSubmit() {
			if (this.mode === "INSERT") {
				this.insert(this.myData).then(() => {
					this.$router.push("/stasi");
				});
			} else {
				this.update(this.myData).then(() => {
					this.$router.push("/stasi");
				});
			}
		},
		findAll() {
			this.$store.dispatch("service/getWilayah");
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs main="Stasi/Lingkungan" title="Form Stasi/Lingkungan" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<b-skeleton-wrapper :loading="isLoading">
								<template #loading>
									<b-row>
										<b-col cols="6">
											<b-card>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
											</b-card>
										</b-col>
										<b-col cols="6">
											<b-card>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
												<b-skeleton width="30%"></b-skeleton>
												<b-skeleton width="90%"></b-skeleton>
											</b-card>
										</b-col>
									</b-row>
								</template>

								<form
									@submit.prevent="onSubmit"
									v-if="show"
									id="form-data"
								>
									<div class="form theme-form">
										<div class="row">
											<div class="col-md-6">
												<div class="form-group">
													<label>Wilayah</label>
													<b-form-select
														v-model="myData.wilayah_id"
														:options="getWilayah"
														size="sm"
                                          required
													></b-form-select>
												</div>
												<div class="form-group">
													<label>Nama</label>
													<input
														v-model="myData.nama"
														class="form-control"
														type="text"
														required
													/>
												</div>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<label>Jenis</label>
													<b-form-select
														v-model="myData.jenis"
														:options="myOptions.jenis"
														size="sm"
                                          required
													></b-form-select>
												</div>
												<transition
													name="custom-classes-transition"
													enter-active-class="animated bounceInRight"
													leave-active-class="animated bounceOutRight"
												>
													<div
														class="form-group"
														v-show="myData.jenis === 'stasi'"
													>
														<label>Nama Gereja</label>
														<input
															v-model="myData.gereja"
															class="form-control"
															type="text"
														/>
													</div>
												</transition>
												<transition
													name="custom-classes-transition"
													enter-active-class="animated bounceInRight"
													leave-active-class="animated bounceOutRight"
												>
													<div
														class="form-group"
														v-show="myData.jenis === 'stasi'"
													>
														<label>Alamat Gereja</label>
														<input
															v-model="myData.gereja_alamat"
															class="form-control"
															type="text"
														/>
													</div>
												</transition>
											</div>
										</div>
										<hr />
										<div class="row">
											<div class="col-md-3">
												<div class="form-group">
													<label>Ketua Wilayah</label>
													<input
														v-model="myData.ketua"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>No HP</label>
													<input
														v-model="myData.ketua_nohp"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>Alamat</label>
													<input
														v-model="myData.ketua_alamat"
														class="form-control"
														type="text"
													/>
												</div>
											</div>
											<div class="col-md-3">
												<div class="form-group">
													<label>Sekretaris Wilayah</label>
													<input
														v-model="myData.sekretaris"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>No HP</label>
													<input
														v-model="myData.sekretaris_nohp"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>Alamat</label>
													<input
														v-model="myData.sekretaris_alamat"
														class="form-control"
														type="text"
													/>
												</div>
											</div>
											<div class="col-md-3">
												<div class="form-group">
													<label>Bendahara Wilayah</label>
													<input
														v-model="myData.bendahara"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>No HP</label>
													<input
														v-model="myData.bendahara_nohp"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>Alamat</label>
													<input
														v-model="myData.bendahara_alamat"
														class="form-control"
														type="text"
													/>
												</div>
											</div>
                                 <div class="col-md-3">
												<div class="form-group">
													<label>Pemimpin Ibadat</label>
													<input
														v-model="myData.pemimpin_ibadat"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>No HP </label>
													<input
														v-model="myData.pemimpin_ibadat_nohp"
														class="form-control"
														type="text"
													/>
												</div>
												<div class="form-group">
													<label>Alamat</label>
													<input
														v-model="myData.pemimpin_ibadat_alamat"
														class="form-control"
														type="text"
													/>
												</div>
											</div>
										</div>
										<hr />
										<div class="row">
											<div class="col">
												<div class="form-group mb-0">
													<b-button
														class="mr-3"
														type="submit"
														variant="primary"
														:disabled="isLoading"
														form="form-data"
													>
														<span
															v-show="isLoading"
															class="spinner-border spinner-border-sm"
														></span
														><i
															class="fa fa-fw fa-save"
															v-show="!isLoading"
														></i>
														Simpan
													</b-button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</b-skeleton-wrapper>
						</div>
					</px-card>
				</div>
			</div>
		</div>
		<!-- Container-fluid Ends-->
	</div>
</template>

